import { useState, useCallback } from 'react';
import { calculateIntervalStringAndType, calculateRawIntervalValue, isAllowedInterval, convertTimeSpanToSeconds, convertSecondsToTimeSpan } from '../utils/wakeupIntervalUtils';
export function useIntervalInput(options) {
    var _a;
    if (options === void 0) { options = {}; }
    var initialTimeSpan = options.initialTimeSpan, _b = options.defaultSeconds, defaultSeconds = _b === void 0 ? 3600 * 12 : _b, _c = options.validateBounds, validateBounds = _c === void 0 ? true : _c;
    var initialSeconds = initialTimeSpan
        ? (_a = convertTimeSpanToSeconds(initialTimeSpan)) !== null && _a !== void 0 ? _a : defaultSeconds
        : defaultSeconds;
    var initialState = calculateIntervalStringAndType(initialSeconds);
    var _d = useState(initialState.intervalString), inputValue = _d[0], setInputValue = _d[1];
    var _e = useState(initialState.intervalType), intervalType = _e[0], setIntervalType = _e[1];
    var _f = useState(initialSeconds), secondsValue = _f[0], setSecondsValue = _f[1];
    var _g = useState(true), isAllowedValue = _g[0], setIsAllowedValue = _g[1];
    var updateInterval = useCallback(function (input, type) {
        if (!input) {
            setInputValue('');
            setIntervalType(type);
            setIsAllowedValue(false);
            return;
        }
        var convertedInterval = calculateRawIntervalValue(input, type);
        if (convertedInterval !== null && !isNaN(convertedInterval)) {
            if (validateBounds && !isAllowedInterval(convertedInterval)) {
                setSecondsValue(convertedInterval);
                setIsAllowedValue(false);
            }
            else {
                setSecondsValue(convertedInterval);
                setIsAllowedValue(true);
            }
        }
        setInputValue(input);
        setIntervalType(type);
    }, [validateBounds]);
    var onInputChange = useCallback(function (value) {
        updateInterval(value, intervalType);
    }, [updateInterval, intervalType]);
    var onTypeChange = useCallback(function (type) {
        updateInterval(inputValue, type);
    }, [updateInterval, inputValue]);
    var onBlur = useCallback(function () {
        // Normalize to best-fit unit on blur
        var _a = calculateIntervalStringAndType(secondsValue), intervalString = _a.intervalString, bestType = _a.intervalType;
        setInputValue(intervalString);
        setIntervalType(bestType);
    }, [secondsValue]);
    var getTimeSpan = useCallback(function () {
        return convertSecondsToTimeSpan(Math.round(secondsValue));
    }, [secondsValue]);
    return {
        inputValue: inputValue,
        intervalType: intervalType,
        secondsValue: secondsValue,
        isAllowedValue: isAllowedValue,
        onInputChange: onInputChange,
        onTypeChange: onTypeChange,
        onBlur: onBlur,
        getTimeSpan: getTimeSpan
    };
}
